import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import Toast from './Toast'; // Import Toast component
import './form.css'; // Import your CSS styles

const StockForm = () => {
  const [scrip, setScrip] = useState("");
  const [date, setDate] = useState("");
  const [rate, setRate] = useState("");
  const [quantity, setQuantity] = useState("");
  const [transactionType, setTransactionType] = useState("BUY");
  const [amount, setAmount] = useState("");

  // Toast states
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [partner, setPartner] = useState("Personal");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const docRef = await addDoc(collection(db, "transactions"), {
        scrip,
        date,
        rate: parseFloat(rate),
        quantity: parseInt(quantity),
        transactionType,
        amount: parseFloat(amount),
        partner
      });

      // Show success toast
      setToastMessage("Transaction added successfully!");
      setToastType("success");
      setShowToast(true);

      setTimeout(() => {
        setShowToast(false);
      }, 3000);

      // Clear the form fields
      setScrip("");
      setDate("");
      setRate("");
      setQuantity("");
      setTransactionType("BUY");
      setAmount("");
      setPartner("Personal");
    } catch (error) {
      // Show error toast
      setToastMessage("Error adding transaction");
      setToastType("error");
      setShowToast(true);

      setTimeout(() => {
        setShowToast(false);
      }, 3000);

      console.error("Error adding document: ", error);
    }
  };

  useEffect(() => {
    if (rate && quantity) {
      const baseAmount = rate * quantity;
      const charges = baseAmount * 0.0036;

      const finalAmount =
        transactionType === "BUY"
          ? baseAmount + charges
          : baseAmount - charges;

      setAmount(finalAmount.toFixed(2));
    } else {
      setAmount("");

    }
  }, [rate, quantity, transactionType]);


  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Scrip:</label>
          <input
            type="text"
            value={scrip}
            onChange={(e) => setScrip(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Date:</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Rate:</label>
          <input
            type="number"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Quantity:</label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Transaction Type:</label>
          <select
            value={transactionType}
            onChange={(e) => setTransactionType(e.target.value)}
          >
            <option value="BUY">Buy</option>
            <option value="SELL">Sell</option>
          </select>
        </div>

        {transactionType === "BUY" ? (
          <div>
            <label>Bill Amount:</label>
            <input
              type="number"
              value={amount}
              readOnly
            />
          </div>
        ) : (
          <div>
            <label>Receivable Amount:</label>
            <input
              type="number"
              value={amount}
              readOnly
            />
          </div>
        )}
        <div>
          <label>Partner:</label>
          <input
            type="text"
            value={partner}
            onChange={(e) => setPartner(e.target.value)}
            placeholder="Enter partner name (default: Personal)"
          />
        </div>

        <button type="submit">Submit</button>

      </form>
      setPartner("Personal");
      {/* Toast notification */}
      <Toast message={toastMessage} type={toastType} show={showToast} />

    </div>

  );
};

export default StockForm;
